<template>
    <div class="card mb-4">
        <div class="card-header">
            <div class="row">
                <div class="col-6">
                    <h3 class="pull-left">
                        <strong>{{ trans.get('checkout.customer_details') }}</strong>
                    </h3>
                </div>
                <div class="col-6">
                    <div class="text-right"></div>
                </div>
            </div>
        </div>
        <div class="card-body">
            <div v-if="this.cartContent.length > 1" class="alert alert-info">
                <strong>{{ trans.get('checkout.note') }}:</strong>
                {{ trans.get('checkout.purchasing_more_than_one_text') }}
            </div>
            <div v-for="(cartItem, cartItemIndex, realCartIndex) in guests" :key="`cart-item-${cartItemIndex}`">
              <template v-if="realCartIndex > 0">
                <hr /><br />
              </template>
              <p class="font-weight-bold clearfix">For product {{ cartItem.name }}</p>
              <b-tabs>
                <b-tab v-for="(guest, guestIndex) in cartItem.list" :key="`cart-item-guest-${cartItemIndex}-${guestIndex}`" :title="guest.lead ? 'Lead' : 'Guest ' + guestIndex">
                  <p class="text-center my-5"><b-btn
                      v-if="cartItem.previous && guestIndex === 0" @click="copyFromPrevious(cartItem.previous, cartItemIndex)">Copy lead details from previous product</b-btn></p>
                  <div class="row">
                    <div class="col-md-6 col-12">
                      <label :for="`first_name-${cartItemIndex}-${guestIndex}`">
                        {{ trans.get('checkout.name') }} <template v-if="guestIndex === 0">*</template>
                      </label>
                      <div class="form__controls form__controls--default">
                        <input-error field="guest.firstname"></input-error>
                        <input :disabled="loading" :id="`firstname-${cartItemIndex}-${guestIndex}`"
                               type="text" class="field form-control"
                               v-model="guest.firstname">
                      </div>
                    </div>
                    <div class="col-md-6 col-12">
                      <label :for="`last_name-${cartItemIndex}-${guestIndex}`">
                        {{ trans.get('checkout.surname') }} <template v-if="guestIndex === 0">*</template>
                      </label>
                      <div class="form__controls form__controls--default">
                        <input-error field="guest.lastname"></input-error>
                        <input :disabled="loading" :id="`last_name-${cartItemIndex}-${guestIndex}`" type="text"
                               class="field form-control" v-model="guest.lastname">
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-6 col-12">
                      <label :for="`phone-${cartItemIndex}-${guestIndex}`">
                        {{ trans.get('checkout.phone') }} <template v-if="guestIndex === 0">*</template>
                      </label>
                      <div class="form__controls form__controls--default">
                        <input-error field="guest.phone"></input-error>
                        <input :disabled="loading" :id="`phone-${cartItemIndex}-${guestIndex}`" type="text"
                               class="field form-control" v-model="guest.phone">
                      </div>
                    </div>
                    <div class="col-md-6 col-12">
                      <label :for="`email-${cartItemIndex}-${guestIndex}`">
                        {{ trans.get('checkout.customer_email') }}
                      </label>
                      <div class="form__controls form__controls--default">
                        <input-error field="guest.email"></input-error>
                        <input :disabled="loading" :id="`email-${cartItemIndex}-${guestIndex}`" type="text" class="field form-control"
                               v-model="guest.email">
                      </div>
                    </div>
                    <div class="col-md-6 col-12">
                      <label :for="`date_of_birth-${cartItemIndex}-${guestIndex}`">
                        {{ trans.get('checkout.date_of_birth') }}
                      </label>
                      <div class="form__controls form__controls--default">
                        <input :disabled="loading" :id="`date_of_birth-${cartItemIndex}-${guestIndex}`" type="text" maxlength="10"
                               class="field form-control" v-model="guest.date_of_birth"
                               placeholder="dd/mm/yyyy"
                        >
                        <b-form-invalid-feedback :state="isDateOfBirthValid(guest.date_of_birth)" class="mt-1">
                          Please enter valid date in format dd/mm/yyyy or leave empty.
                        </b-form-invalid-feedback>
                      </div>
                    </div>
                    <div class="col-md-6 col-12">
                      <label :for="`document-${cartItemIndex}-${guestIndex}`">
                        {{ trans.get('checkout.document') }}
                      </label>
                      <div class="form__controls form__controls--default">
                        <input-error field="guest.document"></input-error>
                        <input :disabled="loading" :id="`document-${cartItemIndex}-${guestIndex}`" type="text" class="field form-control"
                               v-model="guest.document">
                      </div>
                    </div>
                    <div class="col-md-6 col-12">
                      <label :for="`nationality_id-${cartItemIndex}-${guestIndex}`">
                        {{ trans.get('checkout.nationality') }}
                      </label>
                      <div class="form__controls form__controls--default">
                        <select :disabled="loading" v-model="guest.nationality_id" :id="`nationality_id-${cartItemIndex}-${guestIndex}`" class="field form-control">
                          <option :value="null">Select Nationality</option>
                          <option v-for="(name, id) in countries" v-bind:value="id">
                            {{ name }}
                          </option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <hr />
                  <div class="row">
                    <div class="col-md-6 col-12">
                      <label :for="`address_1-${cartItemIndex}-${guestIndex}`">
                        {{ trans.get('checkout.address_1') }}
                      </label>
                      <div class="form__controls form__controls--default">
                        <input :disabled="loading" :id="`address_1-${cartItemIndex}-${guestIndex}`" type="text"
                               class="field form-control" v-model="guest.address_1">
                      </div>
                    </div>
                    <div class="col-md-6 col-12">
                      <label :for="`address_2-${cartItemIndex}-${guestIndex}`">
                        {{ trans.get('checkout.address_2') }}
                      </label>
                      <div class="form__controls form__controls--default">
                        <input :disabled="loading" :id="`address_2-${cartItemIndex}-${guestIndex}`" type="text"
                               class="field form-control" v-model="guest.address_2">
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-6 col-12">
                      <label :for="`county-${cartItemIndex}-${guestIndex}`">
                        {{ trans.get('checkout.county') }}
                      </label>
                      <div class="form__controls form__controls--default">
                        <input :disabled="loading" :id="`county-${cartItemIndex}-${guestIndex}`" type="text"
                               class="field form-control" v-model="guest.county">
                      </div>
                    </div>
                    <div class="col-md-6 col-12">
                      <label :for="`postal-code-${cartItemIndex}-${guestIndex}`">
                        {{ trans.get('checkout.postal_code') }}
                      </label>
                      <div class="form__controls form__controls--default">
                        <input :disabled="loading" :id="`postal_code-${cartItemIndex}-${guestIndex}`" type="text"
                               class="field form-control" v-model="guest.postal_code">
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-6 col-12">
                      <label :for="`city-${cartItemIndex}-${guestIndex}`">
                        {{ trans.get('checkout.city') }}
                      </label>
                      <div class="form__controls form__controls--default">
                        <input :disabled="loading" :id="`city-${cartItemIndex}-${guestIndex}`" type="text"
                               class="field form-control" v-model="guest.city">
                      </div>
                    </div>
                    <div class="col-md-6 col-12">
                      <label :for="`country_id-${cartItemIndex}-${guestIndex}`">
                        {{ trans.get('checkout.country') }}
                      </label>
                      <div class="form__controls form__controls--default">
                        <select :disabled="loading" v-model="guest.country_id" :id="`country_id-${cartItemIndex}-${guestIndex}`" class="field form-control">
                          <option :value="null">Select Country</option>
                          <option v-for="(name, id) in countries" v-bind:value="id">
                            {{ name }}
                          </option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <template v-if="cartItem.options && Object.keys(cartItem.options).length">
                    <hr />
                    <div class="form-group" v-for="(option) in cartItem.options" :key="`cigo-${cartItemIndex}-${guestIndex}-${option.key}`">
                      <label>{{ option.name }}</label>
                      <div class="form__controls form__controls--default">
                        <input class="field form-control" :placeholder="option.name"
                               type="text"
                               v-model="guest.options[option.key]"
                        />
                      </div>
                    </div>
                  </template>
                </b-tab>
              </b-tabs>
          </div>
        </div>
    </div>
</template>

<script>
import {mapFields} from 'vuex-map-fields';
import InputError from './InputError';

export default {
  name: 'customer-details',
  data() {
    return {
      countries: [],
      guest_fields: [],
      product_fields: [],
    };
  },
  computed: {
    ...mapFields([
      'cartTotal',
      'cartContent',
      'currency',
      'order.guests',
      'errors',
      'loading',
    ]),
    isValid() {
      let valid = true;
      Object.keys(this.guests).forEach((index) => {
        this.guests[index].list.forEach((guest, guestIndex) => {
          if (guest.lead) {
            if (!guest.firstname) {
              valid = false;
            }
            if (!guest.lastname) {
              valid = false;
            }
            if (!guest.phone) {
              valid = false;
            }
          }
          if (!this.isDateOfBirthValid(guest.date_of_birth)) {
            valid = false;
          }
        });
      });

      return valid;
    },
  },
  mounted() {
    const root = this;
    root.countries = window.countries ? window.countries : [];
    root.guest_fields = window.guest_fields ? window.guest_fields : [];
    root.product_fields = window.product_fields ? window.product_fields : [];
  },
  components: {
    InputError
  },
  methods: {
    copyFromPrevious(source, target) {
      Object.keys(this.guests[source].list[0]).filter(item => !['id', 'lead'].includes(item)).forEach((item) => {
        if (this.guests[target].list[0].hasOwnProperty(item)) {
          this.guests[target].list[0][item] = this.guests[source].list[0][item];
        }
      });
    },
    isDateOfBirthValid(value) {
      if (value === null || value.length === 0) {
        return true;
      }
      const found = value.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
      if (!found) {
        return false;
      }
      try {
        let date = new Date(found[3], Number(found[2]) - 1, found[1]);

        return Number(found[3]) === date.getFullYear() && (Number(found[2]) - 1) === date.getMonth() && Number(found[1]) === date.getDate();
      }
      catch (exception) {
        return false;
      }
    },
  },
}
</script>

<style scoped>
.form__controls input.field:disabled {
  cursor: default;
  background-color: #E9ECEF !important;
  -webkit-box-shadow: 0 0 0 1000px #E9ECEF inset;
}
</style>
